export default __webpack_public_path__ + "assets/code.3378e2bd.svg";